import { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import productService from "../../services/generalApi/product.service";
import moment from "moment";


export const useCamera = (type:string) => {

    const webcamRef = useRef<Webcam>(null);
    const [imgSrc, setImgSrc] = useState<string | null>(null);

    const [chargingPhoto, setChargingPhoto] = useState<boolean>(false);
    const [photoSaved, setPhotoSaved] = useState<boolean>(false);
    const [photoUrl, setPhotoUrl] = useState<string | null>(null);
    const [photoError, setPhotoError] = useState<boolean>(false);


    const convertBase64ToFormData = async (base64String: string, fileName: string): Promise<FormData> => {
      return new Promise((resolve, reject) => {
          try {
              const binaryString = atob(base64String.split(',')[1]);
              const byteArrays: Uint8Array[] = [];
  
              for (let offset = 0; offset < binaryString.length; offset += 512) {
                  const slice = binaryString.slice(offset, offset + 512);
  
                  const byteNumbers = new Array(slice.length);
                  for (let i = 0; i < slice.length; i++) {
                      byteNumbers[i] = slice.charCodeAt(i);
                  }
  
                  const byteArray = new Uint8Array(byteNumbers);
                  byteArrays.push(byteArray);
              }
  
              const formData = new FormData();
              const blob = new Blob(byteArrays, { type: 'image/jpeg' });
              formData.append('formFile', blob, fileName);
  
              resolve(formData);
          } catch (error) {
              reject(error);
          }
      });
  };

      const generateRandomFileName = (extension: string): string => {
        const randomPart = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        return `${randomPart}.${extension}`;
    };

      const capture = useCallback(() => {
        if (webcamRef.current) {
          const imageSrc = webcamRef.current.getScreenshot();
          setImgSrc(imageSrc);
          setPhotoSaved(true);
        }
      }, [webcamRef]);
    
      useEffect(() => {
        if (imgSrc !== null) {
          setChargingPhoto(true);
          uploadImage(imgSrc).then(url => setPhotoUrl(url.path)).finally(() => setChargingPhoto(false));
        }
      }, [imgSrc])

      async function uploadImage(imgSrc: string) {
        try {
          const fileName = generateRandomFileName('jpg');
          const formDataImage = await convertBase64ToFormData(imgSrc, fileName);
          const currentDate = moment().format('YYYY-MM-DD');

          const response = await productService.postImage(formDataImage, type, moment(currentDate).format('YYYY-MM-DD'));
          return response;
    
        } catch (error) {
          console.error(error);
          setChargingPhoto(false);
          setPhotoUrl(null);
          setPhotoError(true);
        }
      }

      const cleanCapture = () => {
        setImgSrc(null);
        setPhotoUrl(null);
        setPhotoSaved(false);
        setPhotoError(false);
      }

    return {
        webcamRef,
        imgSrc,
        setImgSrc,
        chargingPhoto,
        setChargingPhoto,
        photoSaved,
        setPhotoSaved,
        photoUrl,
        setPhotoUrl,
        photoError,
        setPhotoError,
        capture,
        cleanCapture
    }
}